import {Injectable} from '@angular/core';

import 'rxjs/add/operator/toPromise';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {ApiService} from './api.service';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import {Transport} from '../model/Entities/Transport';

@Injectable()
export class TransportService extends ApiService<Transport> {

    protected apiUrl = 'api/transport';  // URL to web api

    protected getObjectType(): any {
        return Transport;
    }
}



// WEBPACK FOOTER //
// /app/src/services/transport.service.ts